<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-10">
            Talent Profiling Guide
        </div>
        <div class="content margin-bottom-10">
            <a href="/question-set-d">
                <img :src="'images/mpower-new/career/back-arrow.png'" />
            </a>
        </div>
        <div class="content">
            <div class="talent-question-title margin-bottom-10 text-left">
                {{data[loadIndex].title}}
            </div>
            <div class="talent-question-desc line-height-normal text-left">
                {{data[loadIndex].description}} 
            </div>
        </div>
        <div class="content" v-for="(item,index) in data[loadIndex].question" :key="index">
            <div class="talent-category margin-bottom-10 text-left">
                {{item.section}}
            </div>
            <div v-for="(subitem,index) in item.question" :key="index">
                <div class="talent-left-wrapper">
                    <label class="talent-label text-left">
                        {{subitem.title}}
                    </label>
                </div>
                <div class="talent-right-wrapper">
                    
                    <label v-if="item.section.toLowerCase()=='g' && subitem.index!='13'" :class="setg.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="setg" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_g[]" @change="check(setg,'g')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='g' && subitem.index=='13'" class="talent-option talent-option-text total_number_g">
                        <input v-model="setg" class="custom-input-text total_number_g" type="number" name='total_number_g' readonly>
                    </label>

                    <label v-if="item.section.toLowerCase()=='e' && subitem.index!='13'" :class="sete.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="sete" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_e[]" @change="check(sete,'e')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='e' && subitem.index=='13'" class="talent-option talent-option-text total_number_e">
                        <input v-model="sete" class="custom-input-text total_number_e" type="number" name='total_number_e' readonly>
                    </label>

                    <label v-if="item.section.toLowerCase()=='n' && subitem.index!='13'" :class="setn.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="setn" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_n[]" @change="check(setn,'n')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='n' && subitem.index=='13'" class="talent-option talent-option-text total_number_n">
                        <input v-model="setn" class="custom-input-text total_number_n" type="number" name='total_number_n' readonly>
                    </label>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="talent-button-wrapper">
            <a @click="proceed()" class="generali-button-red">
                {{data[loadIndex].button}}
            </a>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
export default {
    name: "Question_set_e",
    data(){
        return {
            setg: [],
            sete: [],
            setn: [],
            conclusion: {},
            loadIndex: 0,
            data: [{
                "language": "en",
                "title": "III. Profession",
                "description": "Ignoring qualification requirements, put a tick ( ✔ ) in the box against those jobs that you think you can do well in.",
                "question": [{
                    "section": "G",
                    "question": [{
                        "index": 1,
                        "title": "Airplane Mechanic"
                    },{
                        "index": 2,
                        "title": "Auto Mechanic"
                    },{
                        "index": 3,
                        "title": "Carpenter"
                    },{
                        "index": 4,
                        "title": "Bulldozer Operator"
                    },{
                        "index": 5,
                        "title": "Surveyor"
                    },{
                        "index": 6,
                        "title": "Construction Inspector"
                    },{
                        "index": 7,
                        "title": "Radio Operator"
                    },{
                        "index": 8,
                        "title": "Petrol Station Worker"
                    },{
                        "index": 9,
                        "title": "Tree Surgeon"
                    },{
                        "index": 10,
                        "title": "Lorry Driver"
                    },{
                        "index": 11,
                        "title": "Machinist"
                    },{
                        "index": 12,
                        "title": "Engineer"
                    },{
                        "index": 13,
                        "title": "TOTAL no. of ticks"
                    }]
                },{
                    "section": "E",
                    "question": [{
                        "index": 1,
                        "title": "Meteorologist"
                    },{
                        "index": 2,
                        "title": "Biologist"
                    },{
                        "index": 3,
                        "title": "Astronomer"
                    },{
                        "index": 4,
                        "title": "Medical Laboratory Technician"
                    },{
                        "index": 5,
                        "title": "Zoologist"
                    },{
                        "index": 6,
                        "title": "Chemist"
                    },{
                        "index": 7,
                        "title": "Independent Research Scientist"
                    },{
                        "index": 8,
                        "title": "Writer of Scientific Articles"
                    },{
                        "index": 9,
                        "title": "Editor of Scientific Articles"
                    },{
                        "index": 10,
                        "title": "Botanist"
                    },{
                        "index": 11,
                        "title": "Scientific Research Worker"
                    },{
                        "index": 12,
                        "title": "Physicist"
                    },{
                        "index": 13,
                        "title": "TOTAL no. of ticks"
                    }]
                },{
                    "section": "N",
                    "question": [{
                        "index": 1,
                        "title": "Poet"
                    },{
                        "index": 2,
                        "title": "Symphony Conductor"
                    },{
                        "index": 3,
                        "title": "Musician"
                    },{
                        "index": 4,
                        "title": "Author"
                    },{
                        "index": 5,
                        "title": "Commercial Artist"
                    },{
                        "index": 6,
                        "title": "Free-Lance Writer"
                    },{
                        "index": 7,
                        "title": "Journalist"
                    },{
                        "index": 8,
                        "title": "Portrait Artist"
                    },{
                        "index": 9,
                        "title": "Concert Singer"
                    },{
                        "index": 10,
                        "title": "Composer"
                    },{
                        "index": 11,
                        "title": "Playwright"
                    },{
                        "index": 12,
                        "title": "Cartoonist"
                    },{
                        "index": 13,
                        "title": "TOTAL no. of ticks"
                    }]
                }],
                "answer": "Yes",
                "button": "Proceed"
            },{
                "language": "cn",
                "title": "III. 专业",
                "description": "不需要顾虑资格要求的问题， 在那些你觉得感兴趣的领域里画 ( ✔ )。 你可以选择超过一个。",
                "question": [{
                    "section": "G",
                    "question": [{
                        "index": 1,
                        "title": "飞机技工"
                    },{
                        "index": 2,
                        "title": "汽车技工"
                    },{
                        "index": 3,
                        "title": "木匠"
                    },{
                        "index": 4,
                        "title": "推土机操作员"
                    },{
                        "index": 5,
                        "title": "测量师"
                    },{
                        "index": 6,
                        "title": "建筑视察员"
                    },{
                        "index": 7,
                        "title": "无线电操作员"
                    },{
                        "index": 8,
                        "title": "加油站工人"
                    },{
                        "index": 9,
                        "title": "树木外科医生"
                    },{
                        "index": 10,
                        "title": "罗里司机"
                    },{
                        "index": 11,
                        "title": "机械师"
                    },{
                        "index": 12,
                        "title": "工程师"
                    },{
                        "index": 13,
                        "title": "✔ 的数量"
                    }]
                },{
                    "section": "E",
                    "question": [{
                        "index": 1,
                        "title": "气象学家"
                    },{
                        "index": 2,
                        "title": "生物学家"
                    },{
                        "index": 3,
                        "title": "天文学家"
                    },{
                        "index": 4,
                        "title": "医药实验室技术人员"
                    },{
                        "index": 5,
                        "title": "动物学家"
                    },{
                        "index": 6,
                        "title": "化学家"
                    },{
                        "index": 7,
                        "title": "独立研究科学家"
                    },{
                        "index": 8,
                        "title": "科学论文作家"
                    },{
                        "index": 9,
                        "title": "科学论文编辑"
                    },{
                        "index": 10,
                        "title": "植物学家"
                    },{
                        "index": 11,
                        "title": "科学研究人员"
                    },{
                        "index": 12,
                        "title": "物理学家"
                    },{
                        "index": 13,
                        "title": "✔ 的数量"
                    }]
                },{
                    "section": "N",
                    "question": [{
                        "index": 1,
                        "title": "诗人"
                    },{
                        "index": 2,
                        "title": "交响乐指挥家"
                    },{
                        "index": 3,
                        "title": "音乐家"
                    },{
                        "index": 4,
                        "title": "作家"
                    },{
                        "index": 5,
                        "title": "商业艺术家"
                    },{
                        "index": 6,
                        "title": "自由工作撰稿人"
                    },{
                        "index": 7,
                        "title": "新闻工作者"
                    },{
                        "index": 8,
                        "title": "人像画画家"
                    },{
                        "index": 9,
                        "title": "演唱会歌手"
                    },{
                        "index": 10,
                        "title": "作曲人"
                    },{
                        "index": 11,
                        "title": "剧作家"
                    },{
                        "index": 12,
                        "title": "漫画家"
                    },{
                        "index": 13,
                        "title": "✔ 的数量"
                    }]
                }],
                "answer": "是",
                "button": "继续"
            },{
                "language": "bm",
                "title": "III. Profesion",
                "description": "Tidak mempedulikan keperluan kelayakan, sila tanda ( ✔ ) di dalam kotak terhadap kerja-kerja yang anda fikir boleh lakukan dengan cukup baik",
                "question": [{
                    "section": "G",
                    "question": [{
                        "index": 1,
                        "title": "Mekanik Kapal Terbang"
                    },{
                        "index": 2,
                        "title": "Mekanik Kereta"
                    },{
                        "index": 3,
                        "title": "Tukang Kayu"
                    },{
                        "index": 4,
                        "title": "Operator Jentolak"
                    },{
                        "index": 5,
                        "title": "Juruukur"
                    },{
                        "index": 6,
                        "title": "Inspektor Pembinaan"
                    },{
                        "index": 7,
                        "title": "Pengendali Radio"
                    },{
                        "index": 8,
                        "title": "Pekerja Stesen Minyak"
                    },{
                        "index": 9,
                        "title": "Pakar Potong Pokok"
                    },{
                        "index": 10,
                        "title": "Pemandu Lori"
                    },{
                        "index": 11,
                        "title": "Jurumesin"
                    },{
                        "index": 12,
                        "title": "Jurutera"
                    },{
                        "index": 13,
                        "title": "Bilangan ✔"
                    }]
                },{
                    "section": "E",
                    "question": [{
                        "index": 1,
                        "title": "Ahli Meteorologi"
                    },{
                        "index": 2,
                        "title": "Ahli Biologi"
                    },{
                        "index": 3,
                        "title": "Ahli Astronomi"
                    },{
                        "index": 4,
                        "title": "Juruteknik Makmal Perubatan"
                    },{
                        "index": 5,
                        "title": "Ahli Zoologi"
                    },{
                        "index": 6,
                        "title": "Ahli Kimia"
                    },{
                        "index": 7,
                        "title": "Saintis Penyelidikan Bebas"
                    },{
                        "index": 8,
                        "title": "Penulis Artikel Saintifik"
                    },{
                        "index": 9,
                        "title": "Editor Artikel Saintifik"
                    },{
                        "index": 10,
                        "title": "Ahli Botani"
                    },{
                        "index": 11,
                        "title": "Pekerja Penyelidikan Saintifik"
                    },{
                        "index": 12,
                        "title": "Pakar Fizik"
                    },{
                        "index": 13,
                        "title": "Bilangan ✔"
                    }]
                },{
                    "section": "N",
                    "question": [{
                        "index": 1,
                        "title": "Penyair"
                    },{
                        "index": 2,
                        "title": "Konduktor Simfoni"
                    },{
                        "index": 3,
                        "title": "Ahli Muzik"
                    },{
                        "index": 4,
                        "title": "Pengarang"
                    },{
                        "index": 5,
                        "title": "Artist Komersial"
                    },{
                        "index": 6,
                        "title": "Penulis Bebas"
                    },{
                        "index": 7,
                        "title": "Wartawan"
                    },{
                        "index": 8,
                        "title": "Artist Potret"
                    },{
                        "index": 9,
                        "title": "Penyanyi Konsert"
                    },{
                        "index": 10,
                        "title": "Komposer"
                    },{
                        "index": 11,
                        "title": "Penulis Drama"
                    },{
                        "index": 12,
                        "title": "Pelukis Kartun"
                    },{
                        "index": 13,
                        "title": "Bilangan ✔"
                    }]
                }],
                "answer": "Ya",
                "button": "Teruskan"
            }]
        }
    },
    mounted(){
        if(localStorage.getItem('talent_test')){
            try{
                this.conclusion = JSON.parse(localStorage.getItem('talent_test'))
                for(var a = 0; a < this.data.length; a++){
                    if(this.conclusion.language==this.data[a].language){
                        this.loadIndex = a
                    }
                }
            }
            catch(e){
                console.log(e)
                localStorage.removeItem('talent_test')
            }
        }
    },
    methods: {
        check(set,setname) {
            this.$el.querySelector(".total_number_"+setname).innerText = set.length;
        },
        proceed(){
            this.conclusion.g3 = 0;
            this.conclusion.e3 = 0;
            this.conclusion.n3 = 0;

            if(this.setg.length > 0){
                for(var g = 0 ; g < (this.setg.length); g++){
                    this.conclusion.g3 += 1;
                }   
            }
            if(this.sete.length > 0){
                for(var e = 0; e < this.sete.length; e++){
                    this.conclusion.e3 += 1;
                }
            }
            if(this.setn.length > 0){
                for(var n = 0; n < this.setn.length; n++){
                    this.conclusion.n3 += 1;
                }
            }
            console.log(this.conclusion)
            localStorage.setItem('talent_test',JSON.stringify(this.conclusion))
            window.scrollTo(0,0);
            this.$router.push({path: 'question-set-f'})
        }
    }
}
</script>